import Task from './task';
import Email from './email';
import Whatsapp from './whatsapp';
import auth from './auth';
import board from './board';
import column from './column';
import template from './template';
import user from './user';
import permission from './permission';
import automation from './automation';
import userassignboard from './userassignboard';
import group from './group';
import compose from './compose';
import automations from './automations';
import comment from './comment';
import internalnotes from './internalnotes';
import property from './property'
import customfield from './customfield';
import draft from './draft';
import label from './label';
import support from './support';
import ImapEmail from './imapEmail';
import OutlookUser from './outlookUser';
import bookingConversation from './bookingConversation';
import companyConfig from './companyConfig';
import taskAssignee from './taskAssignee';
import taskShare from './taskShare';
export default {
    taskAssignee,
    taskShare,
    Task,
    Email,
    Whatsapp,
    ImapEmail,
    OutlookUser,
    bookingConversation,
    board,
    auth,
    column,
    template,
    user,
    permission,
    automation,
    userassignboard,
    group,
    compose,
    automations,
    comment,
    internalnotes,
    customfield,
    property,
    draft,
    label,
    support,
    companyConfig
};
